import {Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef} from '@angular/core';

import Swal from 'sweetalert2';
import {ArquivoAnexoDTO} from '../../../dto/ArquivoAnexoDTO';
import {Tooltip} from 'primeng/tooltip';
import UiSwal from '../../ui/misc/ui-swal';
import {DndDirective} from '../../directives/dnd.directive';
import {UiBasicModule} from '../../ui/components/basic/ui-basic.module';
import {SharedUtilsModule} from '../../shared-utils-module';

@Component({
    selector: 'app-upload-files',
    templateUrl: './upload-files.component.html',
    imports: [
        UiBasicModule,
        Tooltip,
        SharedUtilsModule,
        DndDirective
    ],
    styleUrls: ['./upload-files.component.css']
})
export class UploadFilesComponent implements OnInit {
    @Output() onEmitFiles = new EventEmitter<File[]>();
    @Input() files: File[] = [];
    @Input() arquivosAnexos: ArquivoAnexoDTO[] = [];
    @Input() extensoesPermitidas: string[] = [];
    @Input() maxArquivos;
    @Input() tamanhoMaximoPorArquivo: number = 5242880;
    @ViewChild("inputUploadFiles", {static: false}) uploadFilesInput: ElementRef;

    filesArray: File[] = [];

    /*
    constructor(
        private fileService: FileService
    ) { }

    get isMaxArquivos(): boolean {
        return this.maxArquivos && this.filesArray.length >= this.maxArquivos;
    }

     */
    ngOnInit(): void {
        if (this.files) {
            this.filesArray = this.files;
        }
    }

    clearFiles() {
        this.filesArray = [];
        this.onEmitFiles.emit(this.filesArray);
    }

    getExtensoesPermitidasInput(): string {
        return this.extensoesPermitidas.map(extensao => '.' + extensao.toLowerCase()).join(',');
    }

    uploadFile(inputUploadFiles: HTMLInputElement) {
        inputUploadFiles.click();
    }

    addFiles(event: any) {
        const files = this.fileChange(event?.target);

        if (files.length > 0) {
            for (let i = 0; i < files.length; i++) {
                const file = files[i];

                if (this.validarExtensao(file)) {
                    if (this.validarTamanho(file)) {
                        if (this.maxArquivos && this.filesArray.length >= this.maxArquivos) {
                            Swal.fire({
                                icon: 'warning',
                                title: 'Atenção',
                                text: 'Número máximo de arquivos atingido!'
                            });

                            break;
                        } else {
                            this.filesArray.push(file);
                        }
                    }
                }
            }

            this.uploadFilesInput.nativeElement.value = '';
            this.onEmitFiles.emit(this.filesArray);
        }
    }

    validarExtensao(file: File): boolean {
        const extensao = file.name.split('.').pop()?.toLowerCase();

        if (this.extensoesPermitidas === undefined || this.extensoesPermitidas.length === 0) {
            return true;
        } else {
            if (this.extensoesPermitidas.map(ext => ext.toLowerCase()).includes(extensao)) {
                return true;
            } else {
                UiSwal.fire({
                    icon: 'warning',
                    title: 'Atenção',
                    html: 'Extensão do arquivo não permitida!<br> Extensões permitidas: <strong>' + this.extensoesPermitidas.join(', ') + '</strong>'
                });

                return false;
            }
        }
    }

    validarTamanho(file: File): boolean {
        if (!this.tamanhoMaximoPorArquivo || file.size <= this.tamanhoMaximoPorArquivo) {
            return true;
        } else {
            UiSwal.fire({
                icon: 'warning',
                title: 'Atenção',
                text: 'Tamanho máximo por arquivo: ' + this.formatBytes(this.tamanhoMaximoPorArquivo)
            });

            return false;
        }
    }

    fileChange(event: any): FileList {
        const target = event as HTMLInputElement;

        return target.files!;
    }

    formatBytes(bytes: number, decimals = 2): string {
        if (bytes === 0) return '0 B';

        if (bytes < 1000 ** 1) return bytes + ' B';
        if (bytes < 1000 ** 2) return this.bytesToKB(bytes).toFixed(decimals) + ' KB';
        if (bytes < 1000 ** 3) return this.bytesToMB(bytes).toFixed(decimals) + ' MB';
        else return this.bytesToGB(bytes).toFixed(decimals) + ' GB';
    }

    bytesToGB(bytes: number): number {
        const gigabytes = bytes / (1000 ** 3);

        return gigabytes;
    }

    bytesToMB(bytes: number): number {
        const megabytes = bytes / (1024 ** 2);

        return megabytes;
    }

    bytesToKB(bytes: number): number {
        const kilobytes = bytes / 1024;

        return kilobytes;
    }

    removeFile(fileToRemove: File) {
        this.filesArray = this.filesArray.filter(file => file !== fileToRemove);

        this.uploadFilesInput.nativeElement.value = '';

        this.onEmitFiles.emit(this.filesArray);
    }

    get isMaxArquivos(): boolean {
        return this.maxArquivos && this.filesArray.length >= this.maxArquivos;
    }

    getExtensoesPermitidas() {
        return this.extensoesPermitidas.map(extensao => '.' + extensao).join(', ');
    }
}
